import { useState, useEffect } from 'react';

export interface LanguageSwitcherEvent {
    drawerState: boolean;
    selectedLanguage?: string;
}

const LANGUAGE_SWITCHER_EVENT = 'languageSwitcherStateChange';

export const useLanguageSwitcherEvents = (initialState = false) => {
    const [drawerOpen, setDrawerOpen] = useState(initialState);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const handleStateChange = (event: CustomEvent<LanguageSwitcherEvent>) => {
            if (event instanceof CustomEvent) {
                setDrawerOpen(event.detail.drawerState);
            }
        };

        window.addEventListener(LANGUAGE_SWITCHER_EVENT, handleStateChange as EventListener);

        return () => {
            window.removeEventListener(LANGUAGE_SWITCHER_EVENT, handleStateChange as EventListener);
        };
    }, []);

    const dispatchDrawerState = (drawerState: boolean) => {
        if (typeof window !== 'undefined') {
            const event = new CustomEvent<LanguageSwitcherEvent>(LANGUAGE_SWITCHER_EVENT, {
                detail: { drawerState },
            });
            window.dispatchEvent(event);
        }
    };

    return { drawerOpen, dispatchDrawerState };
};
